import React from 'react';
import LargeCarousel from './LargeCarousel';
import { ProductGridItem } from 'scy/ProductGrid';
import { url as productUrl } from 'shared/models/product';
import styles from './styles.mod.scss';

const ProductGridItemCarousel = ({ products, sliderSettings, onClick }) => (
  <LargeCarousel {...sliderSettings}>
    {products.map(product => (
      <div className={styles.productImageContainer} key={product.sku_id}>
        <ProductGridItem
          product={product}
          includeItemProps
          onButtonClick={() => onClick(product)}
          linkProps={{
            to: productUrl(product)
          }}
          className={styles.productImage}
        />
      </div>
    ))}
  </LargeCarousel>
);

export default ProductGridItemCarousel;
